<script setup>
import { defineProps, onMounted, ref, defineEmits, watch, computed } from "vue";
import { isPhonePortrait } from '@/hooks/common/useUtils';

import { useCustomer } from '@/hooks/shopify-hooks/useCustomer';
import { 
	useCsrFormValidator,
} from "@/hooks/common/useCsrFormValidator";

const props = defineProps({
  stateKey: {
    type: String,
    default: "",
  },
  config: {
    type: Object,
    default: null
  },
  customer: {
    type: Object,
    default: null
  }
});

const birthday = ref('');
const birthdayError = ref('');
const birthdayValidator = ref(true)
const isLoading = ref(false);
const showPhoneNav = ref(false);

const emit = defineEmits(['close', 'cancel']);


if(props.customer.metafield && props.customer.metafield.value){
  birthday.value = props.customer.metafield.value
}


const submitForm = async () => {
  useCsrFormValidator([]).then(async () => {
    const { addBirth } = useCustomer();
    try {
      if(!props.customer.metafield && !birthdayValidator.value){
        return
      }
      if(!birthday.value) {
        return
      }
      // 更新customer
      isLoading.value = true;
      const res =  await addBirth({
          birthday:birthday.value
        }, '',props.config)
      isLoading.value = false;
      console.log('res--->',res)
      if(res){
        emit('loading', false);
        emit('close');
        }
    } catch(e) {
      console.error(e);
      isLoading.value = false;
    }
  });
}

const clickCancel = () => {
  emit('cancel');
}


onMounted(() => {
  showPhoneNav.value = isPhonePortrait();

})
watch(() => isLoading.value, (value) => {
  emit('loading', value);
})

// 可选范围：不能晚于今天，且不能超过 120 年（超出部分置灰）
const pickerOptions = {
  disabledDate(time) {
    const now = new Date();
    // 最早可选日期 = 今天往前推 120 年再 +1 天
    // 这样选到的最早日期周岁为 119，与 handleBirthdayChange 中 age >= 120 报错的规则保持一致
    const minDate = new Date(now.getFullYear() - 120, now.getMonth(), now.getDate() + 1);
    return time.getTime() > now.getTime() || time.getTime() < minDate.getTime();
  }
};

// 校验年龄：必须 >= 16 岁且 < 120 岁
const handleBirthdayChange = (val) => {
  if(props.config.personInfo.birthdateEnableAgeValidation === 'true'){
    birthdayError.value = '';
    if (!val) {
      return
    };
    // value-format 为 yyyy-MM-dd，手动按本地时间解析，避免 new Date(str) 的时区偏差
    const [y, m, d] = String(val).split('-').map(Number);
    const birth = new Date(y, m - 1, d);
    const today = new Date();
    let age = today.getFullYear() - birth.getFullYear();
    const monthDiff = today.getMonth() - birth.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
      age--;
    }
    
    if (age < props.config.personInfo.birthdateMinAge || age >= 120) {
      birthdayError.value = props.config.personInfo.birthdateIncorrectFormatPrompt;
      birthdayValidator.value = false
    } else {
      birthdayValidator.value = true
    }
  }

};
// 日期展示格式：配置值为 YYYY-MM-DD / DD/MM/YYYY / MM/DD/YYYY（dayjs 风格）
// mdesign-plus(基于 Element UI) 的 format 使用 yyyy-MM-dd 风格，需做转换
// 注意：仅影响展示，v-model 的值仍由 value-format="yyyy-MM-dd" 保证为 YYYY-MM-DD
const displayFormat = computed(() => {
  const conf = props.config?.personInfo?.birthdateDisplayFormat || 'YYYY-MM-DD';
  return conf.replace(/YYYY/g, 'yyyy').replace(/DD/g, 'dd');
});
</script>

<template>
  <div :class="{'form-v3-ecommerce': true, 'csr-account-form': true}">
    <div class="csr-account-form__nav-title" v-if="showPhoneNav" @click="() => clickCancel()">
      <div class="csr-account__back__icon"></div>
      {{ config.personInfo.birthdateLabel }}
    </div>
    <form @submit.prevent="submitForm">
      <div class="csr-account-form__field__birth">
        <div class="birthday">
          <div>{{ config.personInfo.birthdateLabel }}</div>
          <MdDate
          :disabled="props.customer.metafield"
            :placeholder="config.personInfo.birthdatePlaceholder"
            v-model="birthday"
            :format="displayFormat"
            value-format="yyyy-MM-dd"
            suffix-icon="iconfont-midea iconcalendar"
            :picker-options="pickerOptions"
            @change="handleBirthdayChange"
            class="account-date"
          />
        <span v-if="birthdayError" class="form-item__content-errors csr-account-form__field--birthday__error">{{ birthdayError }}</span>
        </div>
      </div>
      <div class="csr-account-form__btn-group">
        <button class="csr-account-form__btn md-button-v2 md-button md-button--primary" type="submit">{{ config.confirmButton }}</button> 
        <button class="csr-account-form__btn md-button-v2 md-button md-button--black" type="button" @click="() => clickCancel()">{{ config.cancelButton }}</button> 
      </div>
    </form>
  </div>
</template>

